import * as Sentry from '@sentry/browser'

const logInSentry =
    import.meta.env.VITE_APP_NODE_ENV === 'production' ||
    import.meta.env.VITE_APP_NODE_ENV === 'staging'

/**
 * Record a structured breadcrumb against Sentry (or console in dev).
 * Mirrors the helper in coachee-web/src/services/errorHandler.ts so the
 * magic-link chooser fires the same event names from both SPAs.
 */
export const logBreadcrumb = (
    name: string,
    data?: Record<string, unknown>,
    category: string = 'auth',
) => {
    if (logInSentry) {
        Sentry.addBreadcrumb({
            category,
            type: 'info',
            message: name,
            level: 'info',
            data,
            timestamp: Date.now() / 1000,
        })
    } else {
        console.log(`[breadcrumb] ${name}`, data ?? {})
    }
}

/**
 * Report an error to Sentry (or console in dev). Used for boundary-level
 * failures where breadcrumb-only logging would lose the signal.
 */
export const logError = (error: Error, context?: Record<string, unknown>) => {
    if (logInSentry) {
        Sentry.captureException(error, context ? { extra: context } : undefined)
    } else {
        console.error(`[error] ${error.message}`, context ?? {}, error)
    }
}
